export const appBuildAssetsDir = "/_next/"

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/fav.ico"},{"rel":"stylesheet","href":"https://www.gstatic.com/dialogflow-console/fast/df-messenger/prod/v1/themes/df-messenger-default.css"}],"style":[],"script":[{"src":"https://www.googletagmanager.com/gtag/js?id=AW-807923359","async":true},{"id":"ze-snippet","async":true,"src":"https://static.zdassets.com/ekr/snippet.js?key=03a84f92-0fab-4cd7-8e75-b9c1cb2ce992"},{"id":"dialogFlow","async":true,"src":"https://www.gstatic.com/dialogflow-console/fast/df-messenger/prod/v1/df-messenger.js"}],"noscript":[]}

export const appBaseURL = "/"

export const appCdnURL = "https://dm1mubcttd115.cloudfront.net/web-frontend-next/public"

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"prefetch":false,"prefetchOn":{"visibility":false,"interaction":true},"componentName":"NuxtLink"}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false